module.exports = __webpack_public_path__ + "static/media/main.e77fd379.png";